<template lang="pug">
  .form-group
    label {{ label }}
    input.form-control(v-model="localData" :class="{'input-error': !isValidInput()}" :placeholder="!isValidInput() ? requiredLabel : ''" :disabled="disabled" @input="$emit('update:data', localData, isValidInput())" type="text")
</template>

<script>
import Base from '../base'

export default {
  extends: Base,
  accepts(property) {
    return property.type === 'string'
  }
}
</script>


// WEBPACK FOOTER //
// src/components/metadataeditor/template/default/String.vue